import { defineMessages } from 'react-intl';
import PropTypes from 'prop-types';

const controlsList = [{
  name: 'fontSize',
  labelId: 'FONT_SIZE',
  type: 'slider',
  default: 16,
  options: {
    min: 8,
    max: 40,
    step: 1,
  },
}, {
  name: 'color',
  labelId: 'FONT_COLOR',
  type: 'colorPicker',
  default: '#333',
}, {
  name: 'enableScrolling',
  labelId: 'ENABLE_SCROLLING',
  type: 'switch',
  default: false,
}];

const messages = defineMessages({
  NOTE: {
    id: 'NOTE',
    defaultMessage: 'Note',
  },
  FONT_SIZE: {
    id: 'FONT_SIZE',
    defaultMessage: 'Font Size',
  },
  FONT_COLOR: {
    id: 'FONT_COLOR',
    defaultMessage: 'Font Color',
  },
  ENABLE_SCROLLING: {
    id: 'ENABLE_SCROLLING',
    defaultMessage: 'Enable Scrolling',
  },
});

function NoteStyleControls({
  renderControlGroup,
}) {
  // controls by group, used to present controls in like groups
  const controlsGroups = [{
    labelId: 'NOTE',
    controls: controlsList,
  }];

  return controlsGroups.map(
    (controlsGroup, cgIndex) => renderControlGroup(controlsGroup, messages, cgIndex),
  );
}

NoteStyleControls.propTypes = {
  renderControlGroup: PropTypes.func.isRequired,
};

export default NoteStyleControls;
